export default __webpack_public_path__ + "../img/2133cf62144ca9b4dec81d44a3121721.png";